import { useState, useEffect } from "react"
import styles from "./buttonAnimation.module.scss"
// Import your SVG file
import ArrowIcon from "./assets/icons/arrow-icon.svg" // Adjust path as needed
import { UpIcon } from "../../../assets/icons";

export default function ButtonAnimation() {
  const [activeIndex, setActiveIndex] = useState(1);
 
  const buttons = [
    { id: 0, label: "Installment" },
    { id: 1, label: "One-time" },
    { id: 2, label: "Pay as you go" },
  ]
 
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % buttons.length)
    }, 2000)
 
    return () => clearInterval(interval)
  }, [buttons.length])
 
  return (
    <div className={styles.container}>
      <div className={styles.buttonGroup}>
        {buttons.map((button, index) => (
          <div key={button.id} className={`${styles.button} ${activeIndex === index ? styles.active : ""}`}>
            <span className={styles.buttonText}>{button.label}</span>
          </div>
        ))}
 
        {/* Moving Arrow Indicator with SVG */}
        <div className={`${styles.movingArrow} ${styles[`position${activeIndex}`]}`}>
          <div className={styles.arrowCircle}>
            <UpIcon className={styles.arrowIcon} color="#F9A01B"  />
          </div>
        </div>
      </div>
    </div>
  )
}